module.exports = Ember.HTMLBars.template((function() {
  var child0 = (function() {
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        return fragment;
      }
    };
  }());
  var child1 = (function() {
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        var el1 = dom.createElement("div");
        dom.setAttribute(el1,"class","remove-image");
        dom.appendChild(el0, el1);
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        var hooks = env.hooks, element = hooks.element;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        var element0 = dom.childAt(fragment, [0]);
        element(env, element0, context, "action", ["removePhoto"], {"on": "click"});
        return fragment;
      }
    };
  }());
  return {
    isHTMLBars: true,
    revision: "Ember@1.11.1",
    blockParams: 0,
    cachedFragment: null,
    hasRendered: false,
    build: function build(dom) {
      var el0 = dom.createDocumentFragment();
      var el1 = dom.createComment("");
      dom.appendChild(el0, el1);
      var el1 = dom.createElement("div");
      dom.setAttribute(el1,"class","theme-parameter");
      var el2 = dom.createElement("div");
      dom.setAttribute(el2,"class","parameter-label");
      var el3 = dom.createComment("");
      dom.appendChild(el2, el3);
      dom.appendChild(el1, el2);
      var el2 = dom.createElement("div");
      dom.setAttribute(el2,"class","text-field-wrapper");
      dom.appendChild(el1, el2);
      var el2 = dom.createElement("a");
      dom.setAttribute(el2,"target","_blank");
      dom.setAttribute(el2,"class","site-host");
      var el3 = dom.createComment("");
      dom.appendChild(el2, el3);
      dom.appendChild(el1, el2);
      var el2 = dom.createElement("div");
      dom.setAttribute(el2,"class","caption");
      var el3 = dom.createComment("");
      dom.appendChild(el2, el3);
      dom.appendChild(el1, el2);
      dom.appendChild(el0, el1);
      var el1 = dom.createElement("div");
      dom.setAttribute(el1,"class","theme-parameter");
      var el2 = dom.createElement("div");
      dom.setAttribute(el2,"class","parameter-label");
      var el3 = dom.createComment("");
      dom.appendChild(el2, el3);
      dom.appendChild(el1, el2);
      var el2 = dom.createElement("div");
      dom.setAttribute(el2,"class","parameter-value");
      var el3 = dom.createElement("div");
      dom.appendChild(el2, el3);
      var el3 = dom.createComment("");
      dom.appendChild(el2, el3);
      dom.appendChild(el1, el2);
      dom.appendChild(el0, el1);
      var el1 = dom.createElement("div");
      dom.setAttribute(el1,"class","theme-parameter");
      var el2 = dom.createElement("div");
      dom.setAttribute(el2,"class","parameter-label");
      var el3 = dom.createComment("");
      dom.appendChild(el2, el3);
      dom.appendChild(el1, el2);
      var el2 = dom.createComment("");
      dom.appendChild(el1, el2);
      dom.appendChild(el0, el1);
      var el1 = dom.createElement("div");
      dom.setAttribute(el1,"class","theme-parameter");
      var el2 = dom.createElement("div");
      dom.setAttribute(el2,"class","parameter-label");
      var el3 = dom.createComment("");
      dom.appendChild(el2, el3);
      dom.appendChild(el1, el2);
      var el2 = dom.createComment("");
      dom.appendChild(el1, el2);
      dom.appendChild(el0, el1);
      return el0;
    },
    render: function render(context, env, contextualElement) {
      var dom = env.dom;
      var hooks = env.hooks, get = hooks.get, block = hooks.block, inline = hooks.inline, element = hooks.element, concat = hooks.concat, attribute = hooks.attribute, content = hooks.content;
      dom.detectNamespace(contextualElement);
      var fragment;
      if (env.useFragmentCache && dom.canClone) {
        if (this.cachedFragment === null) {
          fragment = this.build(dom);
          if (this.hasRendered) {
            this.cachedFragment = fragment;
          } else {
            this.hasRendered = true;
          }
        }
        if (this.cachedFragment) {
          fragment = dom.cloneNode(this.cachedFragment, true);
        }
      } else {
        fragment = this.build(dom);
      }
      var element1 = dom.childAt(fragment, [1]);
      var element2 = dom.childAt(element1, [1]);
      var element3 = dom.childAt(element1, [2]);
      var element4 = dom.childAt(fragment, [2]);
      var element5 = dom.childAt(element4, [1]);
      var element6 = dom.childAt(element5, [0]);
      var element7 = dom.childAt(fragment, [3]);
      var element8 = dom.childAt(fragment, [4]);
      var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
      var morph1 = dom.createMorphAt(dom.childAt(element1, [0]),0,0);
      var morph2 = dom.createMorphAt(element3,0,0);
      var attrMorph0 = dom.createAttrMorph(element3, 'href');
      var morph3 = dom.createMorphAt(dom.childAt(element1, [3]),0,0);
      var morph4 = dom.createMorphAt(dom.childAt(element4, [0]),0,0);
      var morph5 = dom.createMorphAt(element5,1,1);
      var morph6 = dom.createMorphAt(dom.childAt(element7, [0]),0,0);
      var morph7 = dom.createMorphAt(element7,1,1);
      var morph8 = dom.createMorphAt(dom.childAt(element8, [0]),0,0);
      var morph9 = dom.createMorphAt(element8,1,1);
      dom.insertBoundary(fragment, 0);
      block(env, morph0, context, "sm-file-input", [], {"registerAs": get(env, context, "fileInput"), "accept": "image", "onFileSelected": "uploadPhoto"}, child0, null);
      inline(env, morph1, context, "t", ["general_parameters.labels.site_name"], {});
      element(env, element2, context, "action", ["redirectToSiteNameSettings"], {"on": "click"});
      attribute(env, attrMorph0, element3, "href", concat(env, ["//", get(env, context, "organization.normalizedHost")]));
      content(env, morph2, context, "organization.normalizedHost");
      inline(env, morph3, context, "t", ["general_parameters.labels.site_name_caption"], {});
      inline(env, morph4, context, "t", ["general_parameters.labels.organization_logo"], {});
      element(env, element6, context, "bind-attr", [], {"style": get(env, context, "imageStyle")});
      element(env, element6, context, "action", ["openFileDialog"], {"on": "click"});
      element(env, element6, context, "bind-attr", [], {"class": ":image-preview isLoading:loading:"});
      block(env, morph5, context, "if", [get(env, context, "organization.logo_medium_url")], {}, child1, null);
      inline(env, morph6, context, "t", ["general_parameters.labels.organization_name"], {});
      inline(env, morph7, context, "sm-text-field", [], {"value": get(env, context, "organization.site_name"), "classNames": "parameter-textarea", "focus-out": "textValueChanged"});
      inline(env, morph8, context, "t", ["general_parameters.labels.organization_about"], {});
      inline(env, morph9, context, "textarea", [], {"value": get(env, context, "organization.about"), "classNames": "parameter-textarea", "focus-out": "textValueChanged"});
      return fragment;
    }
  };
}()));